export const microsoftProvidersKeys = [
  'microsoft',
  'outlook',
  'ews',
  'eas',
] as const;
export const googleProvidersKeys = ['google', 'gmail'] as const;

export const VIRTUAL_CALENDAR_PROVIDER = 'virtual-calendar';
export const GOOGLE_PROVIDER = 'google';
export const MICROSOFT_PROVIDER = 'microsoft';
